import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "templatesVisible"];
import { useState } from 'react';
import { Body, Button, LayoutBox, LayoutHorizontal, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { ButtonRegenerate } from './ButtonRegenerate';
import { useSmartPropertyTemplates } from './SmartPropertyTemplatesProvider/SmartPropertyTemplatesProvider';
import { SmartPropertyTemplateCard } from './SmartPropertyTemplateCard';
import { TEMPLATES_COUNT } from './SmartPropertyTemplatesProvider/constants';
import { CardSmartProperty } from './CardSmartProperty';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BadgeAI } from '../BadgeAI';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SmartPropertyTemplates = _ref => {
  let {
      children,
      templatesVisible = TEMPLATES_COUNT
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    hasError,
    isLoading,
    onRefresh,
    onRetry,
    templates
  } = useSmartPropertyTemplates();
  /**
   * @todo Add back TransitionOpacity when we can figure out the dependencies
   */
  const [isVisible, setIsVisible] = useState(true);
  const hasTemplates = templates.length > 0 && !hasError || isLoading;
  const isButtonDisabled = isLoading || hasError || !isVisible;
  const handleRefresh = () => {
    setIsVisible(false);
    onRefresh();
    setIsVisible(true);
  };
  const templatesToShow = Array.from({
    length: templatesVisible
  }, (_, i) => `${i}`);
  return /*#__PURE__*/_jsxs(LayoutSpaceVertical, Object.assign({
    gap: "space-sm"
  }, rest, {
    children: [/*#__PURE__*/_jsxs(LayoutHorizontal, {
      flexWrap: "wrap",
      gap: "space",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(LayoutBox, {
        flex: "1 1 auto",
        children: children
      }), /*#__PURE__*/_jsxs(LayoutHorizontal, {
        gap: "0",
        justifyContent: "end",
        children: [/*#__PURE__*/_jsx(ButtonRegenerate, {
          disabled: isButtonDisabled,
          onClick: handleRefresh
        }), /*#__PURE__*/_jsx(BadgeAI, {})]
      })]
    }), hasTemplates ? /*#__PURE__*/_jsx(LayoutHorizontal, {
      alignItems: "stretch",
      flexWrap: "wrap",
      gap: "space-md",
      maxInlineSize: "100%",
      overflow: "hidden",
      children: templatesToShow.map(templateIndex => /*#__PURE__*/_jsx(SmartPropertyTemplateCard, {
        flex: "1 1 28rem",
        isLoading: isLoading,
        maxInlineSize: "100%",
        template: templates[Number(templateIndex)]
      }, `template-${templateIndex}`))
    }) : /*#__PURE__*/_jsx(CardSmartProperty, {
      children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
        gap: "space-sm",
        children: [/*#__PURE__*/_jsx(Body, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartPropertyTemplates.card.empty"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onRetry,
          children: "Retry"
        })]
      })
    })]
  }));
};